import { gql } from '@apollo/client';

export const GET_STANDARDS_QUERY = gql`
  query getStandardsQuery(
    $group_id: String
    $company_id: String
    $is_quantitative: Boolean
    $references: [String]
  ) {
    standards(
      group_id: $group_id
      company_id: $company_id
      is_quantitative: $is_quantitative
      references: $references
    ) {
      id
      created
      deleted
      version
      name
      category
      is_quantitative
      require_emission_factor
      require_site_level
      sector {
        id
        path
      }
      reference {
        id
        path
      }
      master_list_standard {
        id
      }
    }
  }
`;

export const GET_STANDARDS_MASTER_LIST_QUERY = gql`
  query getStandardsMasterListQuery($is_quantitative: Boolean) {
    standards_master_list(is_quantitative: $is_quantitative) {
      id
      created
      deleted
      version
      name
      category
      is_quantitative
      require_emission_factor
      require_site_level
      sector {
        id
        path
        parentPath
      }
      reference {
        id
        path
        parentPath
      }
    }
  }
`;

export const GET_UNCONFIGURED_STANDARDS_QUERY = gql`
  query getUnconfiguredStandardsQuery(
    $group_id: String
    $company_id: String
    $is_quantitative: Boolean
  ) {
    unconfigured_standards(
      group_id: $group_id
      company_id: $company_id
      is_quantitative: $is_quantitative
    ) {
      id
      created
      deleted
      version
      name
      category
      is_quantitative
      require_emission_factor
      require_site_level
      sector {
        id
        path
        parentPath
      }
      reference {
        id
        path
        parentPath
      }
    }
  }
`;

export const ALLOW_DELETE_STANDARD_QUERY = gql`
  query allowDeleteStandardQuery($group_id: String, $company_id: String, $standard_id: String) {
    allowDeleteStandard(group_id: $group_id, company_id: $company_id, standard_id: $standard_id)
  }
`;
